const analyticsConfig = {
  pageTracking: {
    clearIds: true,
  },
};

export default analyticsConfig;
